var datatables = $('.datatable:not(.ignore)');
if (datatables.length > 0) {
    datatables.each(function () {
        if (!$.fn.DataTable.isDataTable($(this))) {
            $(this).DataTable({
                responsive: true,
            });
        }
    });
}
